import { apiClient, ApiName } from '@shared/services/api'

export const fetchOpenOperations = (config) => {
  return apiClient.get(ApiName.ADMINS, 'operations/pre', config)
}

export const createOpenOperation = (data) => {
  return apiClient.post(ApiName.ADMINS, 'operations/pre', data)
}

export const editOpenOperation = (data) => {
  return apiClient.put(ApiName.ADMINS, 'operations/pre', data)
}

export const fetchPreOperation = (id) => {
  return apiClient.get(ApiName.ADMINS, `operations/pre/${id}`)
}

export const deletePreOperation = (id) => {
  return apiClient.delete(ApiName.ADMINS, 'operations/pre', id)
}

export const fetchClientBank = (id) => {
  return apiClient.get(ApiName.ADMINS, `operations/pre/recipients/${id}`)
}

export const uploadDocumentPre = (id, formData, onProgress) => {
  return apiClient.post(
    ApiName.ADMINS,
    `operations/pre/${id}/docs`,
    formData,
    {
      'Content-Type': 'multipart/form-data'
    },
    { onUploadProgress: onProgress }
  )
}
